import { useTranslation } from "react-i18next";
import { IdleMedia } from "../components/IdleMedia";
import { LanguagePicker } from "../components/LanguagePicker";
import { ReKeyBanner } from "../components/ReKeyBanner";
import { isReKeyWindowActive } from "../lib/device-auth";
import type { BootstrapPayload } from "../lib/kiosk-client";

interface Props {
  bootstrap: BootstrapPayload;
  onStart: () => void;
}

export function IdlePage({ bootstrap, onStart }: Props) {
  const { t } = useTranslation();
  const reKeyBlocking = isReKeyWindowActive();

  return (
    <div
      className="relative flex flex-col h-full overflow-hidden"
      data-testid="idle-page"
    >
      <IdleMedia
        items={bootstrap.idle_media}
        loopIntervalSeconds={bootstrap.idle_loop_interval_seconds}
      />

      {/* Overlay */}
      <div className="relative z-10 flex flex-col h-full">
        {reKeyBlocking && <ReKeyBanner blocking />}

        {/* Top bar */}
        <div className="flex justify-between items-center px-8 pt-6">
          {bootstrap.brand_config.logo_url ? (
            <img
              src={bootstrap.brand_config.logo_url}
              alt={bootstrap.brand_config.partner_name ?? ""}
              className="h-12 object-contain"
            />
          ) : (
            <span className="text-2xl font-bold text-white drop-shadow">
              {bootstrap.brand_config.partner_name ?? ""}
            </span>
          )}
          <LanguagePicker allowed={bootstrap.languages} />
        </div>

        {/* Center CTA */}
        {!reKeyBlocking && (
          <div className="flex flex-1 flex-col items-center justify-end pb-24 gap-6">
            <p className="text-xl text-white/80 drop-shadow">
              {t("idle.tagline")}
            </p>
            <button
              onClick={onStart}
              className="bg-[var(--kiosk-brand-accent)] text-white text-4xl font-bold px-16 py-8 rounded-full shadow-2xl hover:opacity-90 active:opacity-80 transition-opacity min-h-[100px]"
              aria-label={t("idle.tapToStart")}
            >
              {t("idle.tapToStart")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
